import React,{useState} from 'react'
import './navbar.css'
import {MdOutlineTravelExplore} from 'react-icons/md'
import {AiFillCloseCircle} from 'react-icons/ai'
import {TbGridDots} from 'react-icons/tb'


const Navbar = () => {
  const [active , setActive] = useState('navbar')
  // Function Show Navbar
  const showNavbar = ()=>{
    setActive ('navbar active__navbar')
  }

   // Function remove Navbar
   const removeNavbar = ()=>{
    setActive ('navbar')
  }


  return (
  
        <header className="header flex">
          <div className="container__navbar">
          <div className="logo__div">
            <a href="#" className="logo">
                <h1>
                  <MdOutlineTravelExplore className="icon" /> Go2Bandoeng
                </h1>
            </a>
          </div>

          <div className={active}>
              <ul className="nav__list flex">

                <li className="nav__item">
                  <a href="#home" className="nav__link">Home</a>
                </li>

                
                <li className="nav__item">
                  <a href="#about" className="nav__link">About Us</a>
                </li>

                
                <li className="nav__item">
                  <a href="#destination" className="nav__link">Destination </a>
                </li>

                <li className="nav__item">
                  <a href="#contact" className="nav__link">Contact US</a>
                </li>

                <button className="btn nav__btn"><a href="#">Book Now</a></button>
              </ul>

              <div onClick={removeNavbar} className="close__navbar">
                <AiFillCloseCircle className="icon"/>
            </div>
          </div>
        <div onClick={showNavbar} className="toggle__navbar">
          <TbGridDots className="icon"/>
        </div>
        </div>
        </header>
    
  )
}

export default Navbar